export const PRODUCT_VARIATIONS_POPUP_ID = 'ProductVariationsPopup';
export const PRODUCT_VARIATIONS_SECONDAIRES_POPUP_ID = 'ProductVariationsSecondairesPopup';
